import dayjs from 'dayjs';
import { Directive } from 'vue';

function formatTime(el: HTMLElement, { value }: { value: string }) {
   if (value) {
      return (el.innerHTML = dayjs(value).format('HH:mm'));
   }

   return (el.innerHTML = '');
}

const TimeFormatter: Directive = {
   mounted: formatTime,
   updated: formatTime,
};

export default TimeFormatter;
